module.exports = __webpack_public_path__ + "media/advantage/PXL_20240411_145521230-bef73e54.jpg";